import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import FmdBadIcon from '@mui/icons-material/FmdBad';

/**
 * "Verified" (or "Not verified") beside a property's address in the title of its pages: the
 * property page (pages/MyPropertyDashboardPage) and, for an agent, each page of the listing
 * (components/agent/workspace/WorkspaceView), so they read the same.
 */
const AddressVerifiedChip = ({ verified }) => (
  <Tooltip title={verified ? 'Address has been verified' : 'Address has not been verified'} arrow>
    <Chip
      size="medium"
      label={verified ? 'Verified' : 'Not verified'}
      icon={verified ? <WhereToVoteIcon /> : <FmdBadIcon />}
      sx={{
        ml: 1,
        bgcolor: verified ? '#dcfce7' : '#fef3c7',
        color: verified ? '#15803d' : '#a16207',
        fontWeight: 500,
        '& .MuiChip-icon': {
          color: verified ? '#15803d' : '#a16207'
        }
      }}
    />
  </Tooltip>
);

export default AddressVerifiedChip;
